import qs from 'qs';
import BaseHttp from '../../../plugins/baseHttp';

const get = ({ page, _id, id, code, enabled, percent, franchises, cities,},) => {
  const size = 15;
  const from = ((page || 1) - 1) * size;
  cities = cities?.map((city,) => city?.id,);
  const citiesQuery = cities?.length ? `&cities=${cities}` : '';

  if (_id) {return BaseHttp.
    get(`/coupon/${_id}?franchises=${franchises}${cities}`,);}


  const queryObj = {
    id : id || undefined,
    code : (id) ? undefined : code,
    enabled,
    percent,
    size,
    from: from || undefined,
  };

  const query = `/coupon${qs.stringify(
    queryObj,
    { addQueryPrefix: true, },
  )}&franchises=${franchises}${citiesQuery}`;

  return BaseHttp.get(
    query,
  );
};

const getCompanyTypes = () => {
  return BaseHttp.get('/companies/types',);
};

const getCities = ({franchises, page, search, size, from,},) => {
  size = size || 15;
  if(typeof from === 'undefined') {
    from = ((page || 1) - 1) * size;
  }

  const queryObj = {
    size: size,
    from: from,
    search: search ? `${search}` : undefined,
  };
  const query = `/address/cities/franchises?id=${franchises}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

const getCitiesByIds = (cities,) => {
  return BaseHttp.post('/address/cities/summary', {ids: cities,},);
};

const getCompanies = ({franchises, page, search, size, from,},) => {
  size = size || 15;
  if(typeof from === 'undefined') {
    from = ((page || 1) - 1) * size;
  }

  const queryObj = {
    size: size,
    from: from,
    search: search ? `${search}` : undefined,
  };
  const query = `/companies/franchises?id=${franchises}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

const getCompaniesByIds = (companies,) => {
  return BaseHttp.post('/companies/summary/', {uuids: companies,},);
};

const getUsersByEmailPhone = ({ email, phone, },) => {
  const queryObj = {
    email : email || undefined,
    phone : phone || undefined,
  };

  return BaseHttp.get(`/users?${qs.stringify(queryObj,)}`,);
};

const getUsersByIds = (users,) => {
  return BaseHttp.post('users/search', {
    uuids: users,
  },);
};

const enableCoupon = (_id,) => {
  return BaseHttp.post(`/coupon/enable/${_id}`,);
};

const disableCoupon = (_id,) => {
  return BaseHttp.post(`/coupon/disable/${_id}`,);
};

const post = (coupon,) => {
  return BaseHttp.post('/coupon', coupon,);
};

const put = (coupon,) => {
  return BaseHttp.put('/coupon', coupon,);
};

const removeCoupon = (_id,) => {
  return BaseHttp.delete(`/coupon/${_id}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default{
  get,
  post,
  put,
  getCompanyTypes,
  getCities,
  getCitiesByIds,
  getCompanies,
  getCompaniesByIds,
  getUsersByEmailPhone,
  getUsersByIds,
  enableCoupon,
  disableCoupon,
  removeCoupon,
  handleError,
};
